import { Injectable } from '@angular/core';

import { Auth } from '../auth.service';
import { RequestService } from '../request.service';


@Injectable()
export class ReportService {

  constructor(protected requestService: RequestService, protected auth: Auth) { }

  params={
    method: 'get',
    urlKey:'dashboardInfo'
  }

  getDashboardInfo(queryParams,infoName): Promise<any[]> {
    this.params['urlParams']={infoName:infoName}
    this.params['urlQueryParams']=queryParams

    return this.requestService.makeRequest(this.params)
      .then((response: any) => response.json()); //as Report
  };

  get(params): Promise<any[]> {
    return this.requestService.makeRequest(params)
      .then((response: any) => response.json()); //as Report
  };

  getDefaultReports(params): Promise<any[]> {
    var options = {method:"get"}
    options["urlKey"]="defaultReports"
    options["urlQueryParams"]=params
    return this.requestService.makeRequest(options)
      .then((response: any) => response.json()); //as Report
  };



}



// WEBPACK FOOTER //
// ./src/app/services/reports/report.service.ts